module.exports = __webpack_public_path__ + "static/img/quora.cfc191b4.png";